// 3rd party imports
import * as React from 'react';
import { inject } from 'mobx-react';

// bernie
import { AnalyticsStore } from 'bernie-core';

// shared-ui
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// ui
import { UitkPrimaryButton } from 'uitk-react-button';

// util
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

export interface AffiliateCTAProps extends LocalizedComponentProps {
  locale?: string;
  analytics?: AnalyticsStore;
}

@withLocalization
@inject('analytics')
export class AffiliateCTA extends React.Component<AffiliateCTAProps> {
  public render() {
    const link = `/${modifyLocaleParam(this.props.locale)}/signup`;
    const referrerId = 'Affiliate.Partner.Join.Network';
    const linkName = 'Join Network';

    return (
      <>
        <UitkPrimaryButton
          analytics={this.props.analytics.setupTracker(referrerId, linkName, true)}
          tag={'a'}
          href={link}
          data-cy="sign-up-link"
        >
          <LocalizedText message="lp.join.action.text"/>
        </UitkPrimaryButton>
      </>
    );
  }
}
